export default "__VITE_ASSET__DUD_lZAk__"